module.exports = __webpack_public_path__ + "media/images/desktop/story-script_tap-visual-763aa604103405343eb10c6f90ed6860.png";